import React, { useCallback, useEffect } from "react";
import { Image, Body1, Subtitle2 } from "@fluentui/react-components";
import { StationViewModel } from "@dining/api-client";
import { useStyles } from "./StationCardStyles";
import { useNavigate } from "react-router-dom";
import { appInsightsEvents, trackEvent, useAppStore } from "../../../../common";
import placeHolderImage from "../../../../images/diningPlaceHolderImage.png";

interface StationCardProps {
  station: StationViewModel;
  cafeId: string;
}

export const StationCard = ({ station, cafeId }: StationCardProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "StationCard",
      cafeId,
      stationId: station.id,
      stationName: station.name,
    });
  }, [appInsights, context, cafeId, station.id, station.name]);
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate("/cafe/" + cafeId + "/station/" + station.id);
    trackEvent(appInsights, appInsightsEvents.Usage.Actions.StationSelected, context, {
      cafeId: cafeId,
      stationId: station.id,
    });
  }, [appInsights, context, cafeId, station.id, navigate]);
  return (
    station &&
    cafeId && (
      <div
        data-testid={`stationCard-${station.id}`}
        className={styles.stationCardBody}
        onClick={onClick}
        onKeyPress={onClick}
        tabIndex={0}
        aria-label={`${station.name}. Tap to view station menu.`}
        role="link"
      >
        {station.imageUrl ? (
          <Image
            src={station.imageUrl}
            onError={(e) => {
              // Retry on failing to load.
              e.currentTarget.src = station.imageUrl || placeHolderImage;
            }}
            block={true}
            fit="contain"
            alt="Station Image"
            className={styles.stationImage}
          />
        ) : (
          <Image src={placeHolderImage} className={styles.stationImage} alt="PlaceHolder Image " />
        )}
        <div className={styles.stationText}>
          <Subtitle2 data-testid="stationName">{station.name}</Subtitle2>
          {station.isAvailableOnline && (
            <Body1 data-testid="stationAcceptingOrders" className={styles.stationAcceptsOrders}>
              Accepting Online Orders
            </Body1>
          )}
        </div>
      </div>
    )
  );
};
